export enum FiabilityLevel {
    CONFIDENT = "CONFIDENT",
    OUTDATED_LAST_PRICE_UPDATE = "OUTDATED_LAST_PRICE_UPDATE",
    OLD_LAST_UPDATE = "OLD_LAST_UPDATE",
    FEW_RECENT_PRICES = "FEW_RECENT_PRICES",
}
